import blueLines from './blueLines.png';
import yellowLines from './yellowLines.png';
import orangeLines from './orangeLines.png';

// Choose random default image when one is not provided with Contentful data
const defaultImageOptions = [blueLines, yellowLines, orangeLines];

export const defaultImage = () =>
  defaultImageOptions[Math.floor(Math.random() * defaultImageOptions.length)];
